
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.333 5.333h9.334V4H3.333v1.333zm0 9.334c-.366 0-.68-.13-.941-.392A1.284 1.284 0 012 13.333V4c0-.367.13-.68.392-.942.26-.26.575-.391.941-.391H4V1.333h1.333v1.334h5.334V1.333H12v1.334h.667c.366 0 .68.13.941.391.261.261.392.575.392.942v3.783a4.613 4.613 0 00-1.333-.4v-.716H3.333v6.666h4.2c.078.245.17.478.275.7.106.223.23.434.375.634h-4.85zm8.667.666a3.213 3.213 0 01-2.358-.975A3.213 3.213 0 018.667 12c0-.922.325-1.708.975-2.358A3.213 3.213 0 0112 8.667c.922 0 1.708.325 2.358.975.65.65.975 1.436.975 2.358 0 .922-.325 1.708-.975 2.358-.65.65-1.436.975-2.358.975zm1.117-1.75l.466-.466-1.25-1.25V10h-.666v2.133l1.45 1.45z","fill":"currentColor"}})])
          )
        }
      }
    